// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2cNlA","inputWrap":"Table_inputWrap__3Ldf-","col":"Table_col__1_tt6","bmiTooltip":"Table_bmiTooltip__N4YkQ"};